import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'as-product-chip',
  styleUrl: 'as-product-chip.css',
  shadow: true,
})
export class AsProductChip {

  @Prop() products: any;
  @Prop() trackevent?: any = null;
  @Prop() size?: string = 'default';

  render() {
    if(this.products && this.products.length>0) {
      return (
        <Host>
          <div class={{
            chip: true,
            sizemini: (this.size === 'mini')
          }} onClick={() => { this.trackevent('product_chip_click', { productid: this.products[0]?.platformId?.split("/")?.reverse()?.[0] }); }}>
            <img src={this.products[0].platformProduct.featuredImage.url} alt="Product" width="96" height="96" />
            <span class="icon"><i class="gg-shopping-bag"></i></span>
            {this.products.length > 1 ? `View Products` : 'View Product'}
          </div>
        </Host>
      );
    } else {
    return (
      <Host>
      </Host>
    );
  }
}
}
